import { withTranslate } from "@pathwright/ui/src/components/"
import Success from "@pathwright/ui/src/components/success/Success"
import PathwrightUI from "@pathwright/ui/src/components/ui/PathwrightUI"
import ShareIcons from "global/social/components/ShareIcons"
import { ConnectStores } from "lib/core/store"
import get from "lodash/get"

const tPrefix = "path.completion"

const PathCompletion = (props) => {
  const {
    resource,
    school,
    shareEnabled,
    certificate_url,
    shareInfo,
    goBack,
    t,
    tc,
    Trans
  } = props
  const certificateAction = {
    children: t(`${tPrefix}.view_certificate`),
    href: certificate_url,
    download: true
  }

  const doneAction = {
    children: tc("done"),
    onClick: goBack
  }

  return (
    <PathwrightUI.Provider
      theme={{
        backgroundImage: get(resource, "background_image_blurred_cdn"),
        backgroundOverlay: get(resource, "background_overlay")
      }}
    >
      <Success
        icon="grad-cap"
        heading={t(`${tPrefix}.completion`)}
        body={
          <Trans parent="p" i18nKey={`${tPrefix}.you_completed`}>
            You completed {{ resource_name: resource?.name }} from{" "}
            {{ school_name: school.name }}.
          </Trans>
        }
        primaryAction={certificate_url ? certificateAction : doneAction}
        secondaryAction={certificate_url ? doneAction : null}
        onBackgroundClick={goBack}
      >
        {shareEnabled && (
          <ShareIcons
            title={shareInfo.title}
            scale={false}
            mail={true}
            inverted
          />
        )}
      </Success>
    </PathwrightUI.Provider>
  )
}

PathCompletion.displayName = "PathCompletion"

const mapStateToProps = function (state, ownProps) {
  const { t } = ownProps
  let shareInfo
  const { resource, offering, registration } = state.resourceStore.state
  const { school } = state.schoolStore.state
  const { getAbsoluteURL } = state.navigationStore.request

  const goBack = () => state.navigationStore.action.exitModal()

  const shareEnabled = (offering != null ? offering.visibility : undefined) > 5

  if (shareEnabled) {
    shareInfo = {
      title: `${t(`${tPrefix}.just_completed`)} ${resource?.name} ${t(
        `${tPrefix}.from`
      )} ${school.name}!`
    }
  }

  const certificate_url = registration?.certificate_download_url
    ? getAbsoluteURL(registration.certificate_download_url)
    : null

  const props = _.assign(
    {},
    {
      resource,
      school,
      shareEnabled,
      certificate_url,
      shareInfo,
      goBack
    },
    ownProps
  )

  return props
}

const stores = [
  { store: "resource", watch: ["resource", "offering", "registration"] },
  { store: "school", watch: false },
  { store: "navigation", watch: false }
]

export default withTranslate(
  ConnectStores(PathCompletion, stores, {}, mapStateToProps)
)
